<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <BRow
      class="mb-2"
    >
      <BCol
        cols="12"
        class="px-1"
      >
        <div
          class="card card-body p-3 rounded-lg mt-2"
        >
          <div class="d-flex flex-column flex-md-row align-items-md-center gap-5">
            <div class="flex-grow-1">
              <div class="h3">
                Good {{ greetings }}, <b class="text-primary">{{ currentUser?.name || 'Officer' }}</b>
              </div>
              <div>
                Your team performance summary for month of {{ monthLongFormatter(filters.schedule) }}
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row gap-2">
              <div class="min-w-150px">
                <BFormGroup
                  label="Month"
                  label-for="filterMonth"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <flat-pickr
                    id="filterMonth"
                    v-model="filters.schedule"
                    class="form-control"
                    placeholder="--------- ----"
                    :config="flatPickerConfig"
                  />
                </BFormGroup>
              </div>
            </div>
          </div>
        </div>
      </BCol>
      <BCol
        cols="12"
        class="px-1"
      >
        <DashboardFSOCustomerMemos
          :busy="state.busy"
          :schedule="filters.schedule"
          :customer-memos="assignedMemos"
          class="mt-2"
        />
      </BCol>
      <!-- <BCol
        cols="12"
        class="px-1"
      >
        <DashboardFSOTasks
          :busy="state.busy"
          :assigned-tasks="officerTasks"
          class="mt-2"
        />
      </BCol> -->
      <BCol
        cols="12"
        class="px-1"
      >
        <DashboardActivities
          :busy="state.busy"
          :schedule="filters.schedule"
          :activities="activities"
          class="mt-2"
        />
      </BCol>
    </BRow>

    <!-- <DashboardUpcomingEvents
      ref="upcomingEventDashboard"
      class="mt-2"
      :loading="state.busy"
      :schedule="filters.schedule"
      :events="upcoming_events"
    /> -->
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import createDate from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'

// import TermAndAgreement from '@/views/asm/dashboard/components/TermAndAgreement.vue'
// import DashboardFSOTasks from '@/views/asm/dashboard/DashboardFSOTasks.vue'
import DashboardFSOCustomerMemos from '@/views/asm/dashboard/DashboardFSOCustomerMemos.vue'
// import DashboardUpcomingEvents from '@/views/fso/dashboards/DashboardUpcomingEvents.vue'
import DashboardActivities from '@/views/asm/dashboard/DashboardActivities.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MActivities from '@/mixins/maintenances/activities'
import MCustomers from '@/mixins/accounts/customers'

import { SASMDashboard } from '@/services/asm'

// import Tasks from '@/views/asm/dashboard/Tasks.vue'

export default {

  name: 'ASMDashboardBase',

  components: {
    // TermAndAgreement,
    // DashboardFSOTasks,
    DashboardFSOCustomerMemos,
    // DashboardUpcomingEvents,
    DashboardActivities
    // Tasks
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl,
    MActivities,
    MCustomers
  ],

  middleware: ['auth', 'asm'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false
      },
      tasksCurrentTabIndex: 0,
      selected: {
        area: ''
      },
      filters: {
        schedule: createDate().format('YYYY-MM'),
        cluster: ''
      },
      activities: [],
      upcoming_events: [],
      assignedMemos: {
        totalRows: 0,
        rows: []
      },
      taskSummaries: {
        totalRows: 0,
        rows: []
      },
      officerTasks: {
        totalRows: 0,
        rows: []
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  },

  watch: {
    'selected.cluster' (cluster) {
      this.filters.cluster = cluster?.id || ''
    },
    'filters.cluster' () {
      this.gridProvider()
    },
    'filters.schedule' (schedule) {
      if (!schedule) {
        this.filters.schedule = createDate().format('YYYY-MM')
      } else {
        this.gridProvider()
      }
    }
  },

  mounted () {
    if (this.currentUser) {
      this.selected.area = {
        id: this.currentUser.area || ''
      }

      this.gridProvider()
    }
  },

  methods: {

    async gridProvider () {
      this.state.busy = true

      const payload = {
        schedule: this.filters.schedule,
        area_id: this.currentUser.area
      }

      return SASMDashboard.getActivitySummaries(payload).then(
        ({ data }) => {
          const { activity_summaries: taskSummaries, tasks_progress: taskProgress, customer_memos: assignedMemos } = data

          this.taskSummaries = {
            totalRows: Array.from(taskSummaries || []).length,
            rows: taskSummaries || []
          }

          this.officerTasks = {
            totalRows: Array.from(taskProgress || []).length,
            rows: taskProgress || []
          }

          this.assignedMemos = {
            totalRows: Array.from(assignedMemos || []).length,
            rows: assignedMemos || []
          }
        }
      ).catch(() => {
        this.taskSummaries = {
          totalRows: 0,
          rows: []
        }

        this.officerTasks = {
          totalRows: 0,
          rows: []
        }

        this.assignedMemos = {
          totalRows: 0,
          rows: []
        }
      }).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
